{
  "status": {
    "type": "status",
    "styleProperties": {
      "border-radius": "16px"
    },
    "conditions": [
      {
        "expression": "eq(value, 'true')",
        "styleProperties": {
          "background": "var(--success-50)",
          "color": "var(--success-700)",
          "border": "1px solid var(--Success-200, #ABEFC6)"
        }
      },
      {
        "expression": "eq(value, 'false')",
        "styleProperties": {
          "background": "var(--error-50)",
          "color": "var(--error-700)",
          "border": "1px solid var(--error-200)"
        }
      }
    ]
  },
  "user-avatar": {
    "type": "user-avatar"
  },
  "badge": {
    "type": "badge",
    "styleProperties": {
      "border-radius": "6px",
      "border": "1px solid #D0D5DD",
      "background": "var(--gray-25)",
      "box-shadow": "0px 1px 2px 0px rgba(16, 24, 40, 0.05"
    }
  }
}
